<template>
  <f7-page name="sendInvitations" hide-navbar-on-scroll>
    <f7-navbar sliding back-link>
      <f7-nav-title>{{ $t("common.invitations") }}</f7-nav-title>
      <f7-nav-right> </f7-nav-right>

      <f7-subnavbar
        :inner="false"
        v-if="invitationList && invitationList.length > 12"
      >
        <f7-searchbar
          class="searchbar-invitation"
          search-container=".search-invitation"
          :backdrop="false"
          :placeholder="$t('common.search')"
          search-in=".item-title, .item-subtitle, .item-text, .document_desc"
          style="max-width: 600px; margin: auto"
        >
        </f7-searchbar>
      </f7-subnavbar>
    </f7-navbar>
    <div class="layout_content">
      <div class="left_layout"></div>
      <div class="main_layout">
        <f7-list
          dividers
          strong-ios
          transaction-list
          class="searchbar-not-found"
          v-if="invitationList && invitationList.length === 0"
        >
          <f7-list-item :title="$t('common.nothingFound')"> </f7-list-item>
        </f7-list>
        <f7-list
          v-else
          dividers-ios
          strong-ios
          media-list
          class="search-invitation searchbar-found"
        >
          <f7-list-group>
            <f7-card
              outline
              raised
              v-for="(item, index) in invitationList"
              :key="index"
            >
              <f7-card-content>
                <f7-list-item
                  @click="goToinvitation(item)"
                  :title="$t('invitation.sentBy') + ' ' + item.userName"
                  :text="item.description"
                  :subtitle="
                    $t('common.fromto', {
                      startDate: $dayjs(item.created).format('ll	'),
                      endDate: $dayjs(item.validUntil).format('ll	'),
                    })
                  "
                  :footer="item.url"
                >
                  <template #media>
                    <img
                      :src="item.qr"
                      :alt="$t('common.qrCode')"
                      width="80"
                      style="border-radius: 8px"
                    />
                  </template>
                </f7-list-item>

                <f7-list-item
                  v-if="isAdmin"
                  v-for="invit in item.invited"
                  :subtitle="invit"
                  badge-color="red"
                  :key="invit"
                >
                </f7-list-item>
                <f7-list
                  v-if="isAdmin && item.invitees.length > 0"
                  dividers-ios
                  strong-ios
                  outline
                  media-list
                  accordion-list
                >
                  <f7-list-item
                    accordion-item
                    accordion-item-opened
                    v-for="invitee in item.invitees"
                    :key="invitee.id"
                    :title="invitee.name"
                    :badge="transactionStatus(invitee.status).status"
                    :badge-color="transactionStatus(invitee.status).color"
                  >
                    <f7-accordion-content class="grid medium-grid-cols-2">
                      <f7-button
                        v-if="invitee.status === 'PENDING'"
                        raised
                        fill
                        round-ios
                        small
                        large
                        ripple
                        color="primary"
                        class="margin-horizontal margin-bottom-half"
                        :text="
                          isAdmin ? $t('common.confirm') : $t('common.accept')
                        "
                        @click="updateInvitation(invitee.id, 'ACCEPTED')"
                      >
                      </f7-button>
                      <f7-button
                        raised
                        v-if="invitee.status === 'PENDING'"
                        round-ios
                        fill
                        small
                        large
                        ripple
                        color="red"
                        class="margin-horizontal margin-bottom-half"
                        @click="updateInvitation(invitee.id, 'REJECTED')"
                        :text="
                          isAdmin ? $t('common.reject') : $t('common.decline')
                        "
                      ></f7-button>
                    </f7-accordion-content>
                  </f7-list-item>
                </f7-list>
              </f7-card-content>
              <f7-card-footer v-if="isAdmin" class="padding">
                <f7-link
                  @click="deleteInvitation(item.id)"
                  icon-ios="f7:trash"
                  icon-md="material:delete"
                ></f7-link>
                <f7-link
                  @click="openUpdateInvite(item)"
                  icon-ios="f7:pencil"
                  icon-md="material:edit"
                ></f7-link>
                <f7-link
                  @click="shareInvitation(item)"
                  icon-f7="square_arrow_up"
                  icon-md="material:share"
                ></f7-link>
              </f7-card-footer>
            </f7-card>
          </f7-list-group>
        </f7-list>
        <f7-block-title large class="no-margin-bottom">{{
          $t("common.invitations")
          }}</f7-block-title>
        <f7-list>
          <f7-list-group>
            <f7-list-input
              :label="$t('common.recipients')"
              :value="recipients"
              @blur="textChange()"
              @input="(e) => handleRecipientsInput(e.target.value)"
              resizable
              required
              validate
              type="textarea"
              :placeholder="$t('common.clickToAddUser')"
              :info="$t('common.separateWithComma')"
              :error-message="$t('common.separateWithComma')"
            >
              <template #label v-if="invited.length > 0">
                <f7-block class="invitationRecipients">
                  <f7-chip
                    v-for="(item, index) in invited"
                    :key="index"
                    :class="index > 0 ? 'margin-horizontal-half' : ''"
                    :text="item"
                    deleteable
                    @delete="deleteInvitedChip(item)"
                  ></f7-chip
                ></f7-block>
              </template>
            </f7-list-input>
            <f7-block-title class="item-label"
              >{{ $t("common.description") }}:</f7-block-title
            >
            <f7-text-editor
              :placeholder="$t('common.description')"
              :value="description"
              @texteditor:change="(v) => (description = v)"
              resizable
              required
              validate
              type="texteditor"
              :mode="
                !isNativePlatform || !isTablet
                  ? 'toolbar'
                  : 'keyboard-toolbar'
              "
              :style="
                isNativePlatform || !isTablet
                  ? '--f7-text-editor-height: 300px'
                  : ''
              "
            ></f7-text-editor>
            <f7-list-input
              type="datepicker"
              v-model:value="endDate"
              :calendar-params="{ closeOnSelect: true }"
              :placeholder="$t('common.endDate')"
              readonly
              :info="$t('common.selectEndDate')"
            />
          </f7-list-group>
          <f7-list simple-list>
            <f7-list-item :footer="$t('common.oneTimeOrMultiple')">
              <span class="item-title" v-html="typeText"></span>
              <f7-toggle
                v-model:checked="invitationType"
                color="auto"
              ></f7-toggle>
            </f7-list-item>
          </f7-list>

          <f7-button
            round-ios
            ripple
            raised
            fill
            large
            class="buttons margin-horizontal"
            color="red"
            @click="createNewInvitation()"
            >{{ $t("common.create") }}</f7-button
          >
        </f7-list>
      </div>
      <div class="right_layout"></div>
    </div>

    <AdaptiveSheet
      class="updateInvitationsPopup"
      style="--f7-sheet-bg-color: #fff"
      :tablet-fullscreen="true"
      full-screen
      :backdrop="false"
    >
      <f7-view>
        <f7-page
          name="updateInvitation"
          hide-navbar-on-scroll
          ptr
          :ptr-mousewheel="true"
          @ptr:refresh="loadMore"
        >
          <f7-navbar sliding no-shadow>
            <f7-nav-title>{{ $t("common.updateInvitation") }}</f7-nav-title>
            <f7-nav-right>
              <f7-link
                sheet-close=".updateInvitationsPopup"
                popup-close=".updateInvitationsPopup"
              >
                <f7-icon ios="f7:multiply" md="material:close"></f7-icon>
              </f7-link>
            </f7-nav-right>
          </f7-navbar>
          <div class="layout_content">
            <div class="left_layout"></div>
            <div class="main_layout">
              <f7-block-title
                block-title-medium
                v-if="isAdmin"
                class="no-margin-bottom"
                >{{ $t("common.invitations") }}</f7-block-title
              >
              <f7-list v-if="isAdmin">
                <f7-list-group>
                  <f7-list-input
                    :label="$t('common.recipients')"
                    :value="recipients"
                    @blur="textChange()"
                    @input="(e) => handleRecipientsInput(e.target.value)"
                    resizable
                    required
                    validate
                    type="textarea"
                    :placeholder="$t('common.clickToAddUser')"
                    :error-message="$t('common.separateWithComma')"
                    :info="$t('common.separateWithComma')"
                  >
                    <template #label v-if="invited.length > 0">
                      <f7-block class="invitationRecipients">
                        <f7-chip
                          v-for="(item, index) in invited"
                          :key="index"
                          :class="index > 0 ? 'margin-horizontal-half' : ''"
                          :text="item"
                          deleteable
                          @delete="deleteInvitedChip(item)"
                        ></f7-chip
                      ></f7-block>
                    </template>
                  </f7-list-input>
                  <f7-block-title class="item-label"
                    >{{ $t("common.description") }}:</f7-block-title
                  >
                  <f7-text-editor
                    :placeholder="$t('common.description')"
                    :value="description"
                    @texteditor:change="(v) => (description = v)"
                    resizable
                    required
                    validate
                    type="texteditor"
                    :mode="'toolbar'"
                    :style="
                      isNativePlatform || !isTablet
                        ? '--f7-text-editor-height: 300px'
                        : ''
                    "
                  ></f7-text-editor>
                  <f7-list-input
                    type="datepicker"
                    :calendar-params="{ closeOnSelect: true }"
                    v-model:value="endDate"
                    :placeholder="$t('common.endDate')"
                    readonly
                    :info="$t('common.selectEndDate')"
                  />
                </f7-list-group>
              </f7-list>
              <f7-list simple-list>
                <f7-list-item :footer="$t('common.oneTimeOrMultiple')">
                  <span class="item-title" v-html="typeText"></span>
                  <f7-toggle
                    v-model:checked="invitationType"
                    color="auto"
                  ></f7-toggle>
                </f7-list-item>
              </f7-list>
              <f7-button
                v-if="invitationToUpdate"
                round-ios
                ripple
                raised
                fill
                large
                class="buttons margin-horizontal"
                color="primary"
                @click="updateInvitation()"
                >{{ $t("common.update") }}</f7-button
              >
              <f7-button
                v-else
                round-ios
                ripple
                raised
                fill
                large
                class="buttons margin-horizontal"
                color="red"
                @click="createNewInvitation()"
                >{{ $t("common.create") }}</f7-button
              >
            </div>
            <div class="right_layout"></div>
          </div>
        </f7-page>
      </f7-view>
    </AdaptiveSheet>
  </f7-page>
</template>
<style scoped>
.invitationRecipients {
  word-break: break-all;
  white-space: normal;
  overflow-wrap: break-word;
  margin: 0px 0px;
  padding: 0px 0px;
}
</style>
<script setup>
import { ref, computed, onMounted } from 'vue'
import i18n from '@/js/i18n.js'
import { f7 } from 'framework7-vue'
import _ from 'lodash'
import { useInvitation } from '../js/composables/useInvitation.js'
import { useSocialShare } from '../js/composables/useSocialShare.js'
import AdaptiveSheet from '../components/common/AdaptiveSheet.vue'

const props = defineProps({
  f7route: Object,
  f7router: Object,
  projectList: Array,
  entityType: String,
  entityId: String,
  currentUser: Object,
  isAdmin: Boolean,
  entity: Object,
  memberList: Object,
})

const description = ref('')
const invitationType = ref('oneTime')
const validUntil = ref('')
const endDate = ref('')
const invited = ref([])
const recipients = ref('')
const invitationToUpdate = ref(null)

const {
  profile, isDeskTop, isTablet, locale, documentsUrl, document: authDocument, isNativePlatform,
  userDetail, userAccount, users,
  invitationList, invitation,
  destinationCity, country,
  typeText,
  getGroupInvitationList, loadMore, openUpdateInvite, shareInvitation,
  handleRecipientsInput, textChange, deleteInvitedChip,
  updateInvitation, acceptInvitation, changeInvitationStatus,
  deleteInvitation, createNewInvitation, goToinvitation,
} = useInvitation({
  f7route: props.f7route,
  f7router: props.f7router,
  entityId: props.entityId,
  entityType: props.entityType,
  entity: props.entity,
  isAdmin: props.isAdmin,
  memberList: props.memberList,
  description,
  invitationType,
  validUntil,
  endDate,
  invited,
  recipients,
  invitationToUpdate,
})

const { socialShare } = useSocialShare()

function shareInvitationLocal(item) {
  const sharedContent = {
    message: item.description,
    subject: item.groupName,
    files: [item.qr, 'https://avocash.com/34x34.png'],
    short: false,
    linkBase: '',
    url: item.url,
  }
  socialShare(sharedContent)
}

function transactionStatus(status) {
  const statusMap = {
    PENDING: { status: 'Pending', color: 'orange' },
    ACCEPTED: { status: 'Accepted', color: 'green' },
    REJECTED: { status: 'Rejected', color: 'red' },
  }
  return statusMap[status] || { status, color: 'gray' }
}

onMounted(() => {
  getGroupInvitationList()
})
</script>
